/* so-buy-module.js — wraps the contiguous buy-column blocks (selector → buy-buttons)
   into one <div class="so-buy-module"> so CSS can present them as one card.
   Wrap-don't-rebuild: only reparents existing blocks; never touches form/pre-order/min-qty.
   Idempotent + graceful (no-op if the expected blocks aren't found). */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function wrap() {
    var info = document.querySelector('.product-info__sticky') || document.querySelector('.product-info');
    if (!info) return;
    if (info.querySelector(':scope > .so-buy-module')) return; // already wrapped

    var kids = Array.prototype.slice.call(info.children);
    var end = kids.filter(function (el) { return el.querySelector && el.querySelector('[name="add"]'); })[0];
    if (!end) return;                                // graceful: leave the column untouched
    // Start at the variant picker (multi-variant); fall back to the inventory block, then
    // the buy-buttons block itself (single-variant products have no picker).
    var start = kids.filter(function (el) { return el.querySelector && el.querySelector('variant-picker'); })[0]
             || kids.filter(function (el) { return el.tagName === 'PRODUCT-INVENTORY' || (el.querySelector && el.querySelector('product-inventory')); })[0]
             || end;

    var a = kids.indexOf(start), b = kids.indexOf(end);
    if (a < 0 || b < 0 || b < a) return;

    var mod = document.createElement('div');
    mod.className = 'so-buy-module';
    mod.setAttribute('data-so-bm', '');
    start.parentNode.insertBefore(mod, start);
    for (var i = a; i <= b; i++) { mod.appendChild(kids[i]); }

    // Collapse structural empties so the module's flex gap has no phantom slots.
    // (The variant-drawer host is emptied once its trigger/drawer are relocated; the
    //  backorder block and the asset link/script carry no visible content here.)
    Array.prototype.slice.call(mod.children).forEach(function (el) {
      var tag = el.tagName;
      if (tag === 'LINK' || tag === 'SCRIPT') { el.style.display = 'none'; return; }
      if (el.classList && el.classList.contains('product-backorder')) { el.style.display = 'none'; return; }
      if (el.querySelector && el.querySelector('so-variant-drawer')) { el.style.display = 'none'; return; }
    });

    // Tighten the flavour-description into a caption under the selector. (Its block keeps a
    // theme margin that wins the CSS cascade by source order; an inline !important is reliable.)
    var descEl = mod.querySelector('.flavour-description');
    var descBlk = descEl && descEl.closest('.product-info__block');
    if (descBlk && descBlk.parentNode === mod) descBlk.style.setProperty('margin-top', '-6px', 'important');
  }

  ready(wrap);
})();
